import React, { useState } from 'react';
import categoriesData from '../data/categories.json';
import productsData from '../data/products.json';
import { useCart } from '../context/CartContext';
import { Modal, Button } from 'react-bootstrap';

const Menu = () => {
  const [activeTab, setActiveTab] = useState('Smoothies');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSize, setSelectedSize] = useState('small');
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showCartModal, setShowCartModal] = useState(false);
  const [sizeUpgrades, setSizeUpgrades] = useState({ medium: false, large: false });
    const { addToCart } = useCart();

    const calculatePrice = (basePrice, upgrades) => {
      let total = basePrice;
      if (upgrades.medium) total += 1.99;
      if (upgrades.large) total += 3.99;
      return total.toFixed(2);
    };

  const handleViewDetail = (product) => {
    setSelectedProduct(product);
    setShowDetailModal(true);
  };

  const handleAddToCartClick = (product, category) => {
    setSelectedProduct(product);
    setShowCartModal(true);
  };

  const handleAddToCart = () => {
    if (selectedProduct) {
      if (activeTab === 'Juices') {
        // For juices, use the price directly from the product
        addToCart(selectedProduct);
      } else {
        // For other categories, calculate price based on size
        const basePrice = 5.99;
        const finalPrice = calculatePrice(basePrice, sizeUpgrades);
        addToCart({
          ...selectedProduct,
          selectedSize: {
            name: sizeUpgrades.large ? 'Large' : sizeUpgrades.medium ? 'Medium' : 'Small',
            volume: sizeUpgrades.large ? '710 ml' : sizeUpgrades.medium ? '500 ml' : '355 ml',
            price: `$${finalPrice} CAD`
          },
          price: `$${finalPrice} CAD`
        });
      }
      setShowCartModal(false);
    }
  };

  return (
    <>
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-0 gx-5 align-items-end">
            <div className="col-lg-6">
              <div className="section-header text-start mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: '500px'}}>
                <h1 className="display-5 mb-3">Our Menu</h1>
                <p>Discover our range of fresh, organic juices, smoothies, and bowls—crafted with the finest ingredients for your health and wellness.</p>
              </div>
            </div>
            <div className="col-lg-6 text-start text-lg-end wow slideInRight" data-wow-delay="0.1s">
              <ul className="nav nav-pills d-inline-flex justify-content-end mb-5">
                {Object.keys(productsData).map((category, index) => (
                  <li key={category} className="nav-item me-2">
                    <button 
                      className={`btn border-2 btn-outline-primary`}
                      onClick={() => setActiveTab(category)}
                    >
                      {category}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="tab-content">
            {Object.keys(productsData).map(category => (
              <div key={category} className={`tab-pane fade ${activeTab === category ? 'show active' : ''} p-0`}>
                <div className="row g-4">
                  {productsData[category].map((product, index) => (
                    <div key={index} className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.2}s`}>
                      <div className="product-item">
                        <div className="ratio ratio-1x1 bg-light overflow-hidden position-relative">
                          <img className="w-100 h-100 d-block" src={product.image} alt={product.name} style={{objectFit: 'cover', objectPosition: 'center'}} />
                        </div>
                        <div className="text-center p-4">
                          <a className="d-block h5 mb-2" href="#">{product.name}</a>
                          <span className="text-brand me-1">{product.price}</span>
                          <span className="text-body text-decoration-line-through">{product.oldPrice}</span>
                        </div>
                        <div className="d-flex border-top">
                          <small className="w-50 text-center py-2">
                            <a className="text-brand" href="#" onClick={(e) => { e.preventDefault(); handleViewDetail(product); }}>
                              <i className="fa fa-eye text-brand me-2"></i>View detail
                            </a>
                          </small>
                          <small className="w-50 text-center py-2">
                            <a className="btn btn-link text-brand p-0" href={product.link} target="_blank" rel="noopener noreferrer">
                              <i className="fa fa-shopping-bag text-brand me-2"></i>Order Online
                            </a>
                          </small>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Detail Modal */}
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedProduct?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedProduct && (
            <>
              {selectedProduct.sizes && (
                <div className="mb-3">
                  <strong>Available Sizes:</strong>
                  <ul className="list-unstyled mt-2">
                    {selectedProduct.sizes.map((size, idx) => (
                      <li key={idx}>{size.name} ({size.volume}) - {size.price}</li>
                    ))}
                  </ul>
                </div>
              )}
              {selectedProduct.ingredients ? (
                <div className="mb-3">
                  <strong>Ingredients:</strong>
                  <div>{selectedProduct.ingredients}</div>
                </div>
              ) : (
                <div className="mb-3 text-muted">No ingredient info available.</div>
              )}
              {selectedProduct.hasAlcoholicItems !== undefined && (
                <div><strong>Contains Alcohol:</strong> {selectedProduct.hasAlcoholicItems ? 'Yes' : 'No'}</div>
              )}
              {selectedProduct.isVegetarian !== undefined && (
                <div><strong>Vegetarian:</strong> {selectedProduct.isVegetarian ? 'Yes' : 'No'}</div>
              )}
              {selectedProduct.isVegan !== undefined && (
                <div><strong>Vegan:</strong> {selectedProduct.isVegan ? 'Yes' : 'No'}</div>
              )}
              {selectedProduct.isGlutenFree !== undefined && (
                <div><strong>Gluten Free:</strong> {selectedProduct.isGlutenFree ? 'Yes' : 'No'}</div>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Size Selection Modal */}
      <Modal show={showCartModal} onHide={() => setShowCartModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedProduct?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="size-selection">
              {activeTab === 'Juices' ? (
                <>
                  <h5>Base Size: 500 ml - {selectedProduct?.price}</h5>
                  <div className="alert alert-info">
                    Total Price: {selectedProduct?.price}
                  </div>
                </>
              ) : (
                <>
                  <h5>Base Size: Small (355 ml) - $5.99 CAD</h5>
                  <div className="form-check my-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="mediumUpgrade"
                      checked={sizeUpgrades.medium}
                      onChange={(e) => setSizeUpgrades({ ...sizeUpgrades, medium: e.target.checked, large: false })}
                    />
                    <label className="form-check-label" htmlFor="mediumUpgrade">
                      Upgrade to Medium (500 ml) +$1.99 CAD
                    </label>
                  </div>
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="largeUpgrade"
                      checked={sizeUpgrades.large}
                      onChange={(e) => setSizeUpgrades({ ...sizeUpgrades, large: e.target.checked, medium: false })}
                    />
                    <label className="form-check-label" htmlFor="largeUpgrade">
                      Upgrade to Large (710 ml) +$3.99 CAD
                    </label>
                  </div>
                  <div className="alert alert-info">
                    Total Price: ${calculatePrice(5.99, sizeUpgrades)} CAD
                  </div>
                </>
              )}
            </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCartModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddToCart}>
            Add to Cart
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Menu;